module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume002.4dc57a03.webp";